import React from "react";

export enum RemitUploadActionType {
  StartSubmission,
  SubmissionComplete,
  SubmissionError,
  DismissToast,
}

export type RemitUploadAction = {
  type: RemitUploadActionType;
  message?: string;
};

export enum RemitSubmissionState {
  Idle,
  Submitting,
  Complete,
  Error,
}

export interface RemitUploadState {
  submissionState: RemitSubmissionState;
  toastVisible: boolean;
  toastId: number;
  errorMessage?: string;
}

export type RemitUploadContextType = {
  state: RemitUploadState;
  dispatch: React.Dispatch<RemitUploadAction>;
};

export const RemitUploadContext = React.createContext<
  RemitUploadContextType | undefined
>(undefined);

export const RemitUploadReducer = (
  state: RemitUploadState,
  action: RemitUploadAction
): RemitUploadState => {
  switch (action.type) {
    case RemitUploadActionType.StartSubmission:
      return {
        ...state,
        submissionState: RemitSubmissionState.Submitting,
        toastVisible: true,
        errorMessage: undefined,
      };
    case RemitUploadActionType.SubmissionComplete:
      return {
        ...state,
        submissionState: RemitSubmissionState.Complete,
        toastVisible: true,
        errorMessage: undefined,
      };
    case RemitUploadActionType.SubmissionError:
      return {
        ...state,
        submissionState: RemitSubmissionState.Error,
        toastVisible: true,
        errorMessage: action.message,
      };
    case RemitUploadActionType.DismissToast:
      return {
        ...state,
        submissionState: RemitSubmissionState.Idle,
        toastVisible: false,
        toastId: state.toastId + 1,
        errorMessage: undefined,
      };
    default:
      return state;
  }
};

export const useRemitUpload = (): RemitUploadContextType => {
  const context = React.useContext(RemitUploadContext);

  if (context === undefined) {
    throw new Error(
      "useRemitUpload must be used within RemitUploadContext's Provider"
    );
  }

  return context;
};
